import { render } from "./PageTutorialLauncher.vue?vue&type=template&id=1905dc63"
import script from "./PageTutorialLauncher.vue?vue&type=script&lang=js"
export * from "./PageTutorialLauncher.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__